import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  description: 'Add more information to this Invoice to see activity.',
  editInvoice: 'Edit Invoice',
  title: 'No Activity Yet',
})
